import { GeofenceBorderStyle } from '@ti/contracts'

import { GeofenceColor, GeofenceStyle } from '../contracts'

export const ADDITIONAL_MAP_PADDING = 24
export const BASE_MAP_PADDING = 26
export const MOBILE_MAP_PADDING = 18

export const BorderStyleData: Record<GeofenceBorderStyle, [number, number]> = {
  [GeofenceBorderStyle.Dashed]: [4, 4],
  [GeofenceBorderStyle.Dotted]: [0.5, 2],
  [GeofenceBorderStyle.Solid]: [1, 0],
}

export const GeofenceStyles: Record<GeofenceColor, GeofenceStyle> = {
  [GeofenceColor.Purple]: {
    fill: '#E5D7FF',
    fillOpacity: 0.4,
    border: '#b692f6',
    button: '#BD90FD',
  },
  [GeofenceColor.Red]: {
    fill: '#FCD7DA',
    fillOpacity: 0.4,
    border: '#E28F99',
    button: '#BA2C2F',
  },
  [GeofenceColor.Orange]: {
    fill: '#F8ECE5',
    fillOpacity: 0.4,
    border: '#E28A59',
    button: '#D4743F',
  },
  [GeofenceColor.Yellow]: {
    fill: '#FFF4BD',
    fillOpacity: 0.4,
    border: '#EFCF30',
    button: '#D9BB25',
  },
  [GeofenceColor.Green]: {
    fill: '#DFFFCD',
    fillOpacity: 0.4,
    border: '#7FCF50',
    button: '#64AF38',
  },
  [GeofenceColor.LightBlue]: {
    fill: '#C2F1FF',
    fillOpacity: 0.4,
    border: '#67C8E5',
    button: '#4FAFDC',
  },
  [GeofenceColor.Blue]: {
    fill: '#E2E2F6',
    fillOpacity: 0.4,
    border: '#929AD5',
    button: '#5A66C1',
  },
  [GeofenceColor.Brown]: {
    fill: '#E9DAC7',
    fillOpacity: 0.4,
    border: '#BF915F',
    button: '#9E6933',
  },
}

export const DEFAULT_GEOFENCE_COLOR = GeofenceColor.Purple
export const DEFAULT_GEOFENCE_STYLE = GeofenceStyles[DEFAULT_GEOFENCE_COLOR]
export const DEFAULT_GEOFENCE_BORDER_STYLE = GeofenceBorderStyle.Solid
